import { render } from "./TabBox.vue?vue&type=template&id=733c7d65"
import script from "./TabBox.vue?vue&type=script&lang=js"
export * from "./TabBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\dev\\marion-clerk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__